import * as React from 'react';

import ImageGalleryGrid from 'components/ImageGalleryGrid';

import fishersNKWedding from 'gallery/fishers-nkwedding.jpg';
import zaragoza from 'gallery/zaragoza.gif';
import clubcafe from 'gallery/clubcafe.jpeg';
import london from 'gallery/london.jpg';
import southAfrica from 'gallery/SouthAfrica.jpg';
import cedarst from 'gallery/cedarst.jpg';
import h2tb2 from 'gallery/h2tb2.jpg';
import starwars from 'gallery/starwars.jpg';
import h2tb from 'gallery/h2tb.jpg';
import silly from 'gallery/silly.jpg';
import malta from 'gallery/malta.jpg';
import tuxes from 'gallery/tuxes.jpg';
import blade from 'gallery/blade.jpg';
import mcewan from 'gallery/mcewan.jpg';
import ibiza from 'gallery/ibiza.jpg';
import thailand from 'gallery/thailand.jpg';
import LA from 'gallery/LA.jpg';
import emwed from 'gallery/emwed.jpg';
import berlin from 'gallery/berlin.jpg';
import miami from 'gallery/miami.jpg';
import jtree from 'gallery/jtree.jpg';
import fishersssm from 'gallery/fishersssm.jpg';
import skiing from 'gallery/skiing.jpg';
import fisherNKWeddingGif from 'gallery/fishers-nkwedding.gif';
import silly2 from 'gallery/silly2.jpg';
import nye from 'gallery/nye.jpg';
import fireisland from 'gallery/fireisland.jpg';
import ptown from 'gallery/ptown.jpg';
import weddings from 'gallery/weddings.jpg';
import oysters from 'gallery/oysters.jpg';
import nyaj from 'gallery/nyaj.jpg';
import early from 'gallery/early.jpg';


const itemData = [
  {
    src: fishersNKWedding, 
    title: "At Cait & Nik's Wedding",
    rows: 1,
    cols: 4,
  },
  
  {
    src: zaragoza,
    title: 'Zaragoza, Spain',
    rows: 1,
    cols: 1,
  },
  {
    src: clubcafe,
    title: 'Celebrating our engagement',
    rows: 1,
    cols: 2,
  },
  {
    src: london,
    title: 'Out in London, UK',
    rows: 2,
    cols: 1,
  },
  {
    src: southAfrica,
    title: 'Seeing the wild-life near Cape Town, South Africa',
    rows: 2,
    cols: 2,
  },
  {
    src: cedarst,
    title: 'One of our first kisses',
    rows: 1,
    cols: 1,
  },
  {
    src: h2tb2,
    title: 'Celebrating after completing "Harbor to the Bay"',
    rows: 2,
    cols: 1,
  },
  {
    src: starwars,
    title: 'May the force be with us',
    rows: 1,
    cols: 1,
  },
  {
    src: h2tb,
    title: 'Riding "Harbor to the Bay" raising money for AIDS',
    rows: 1,
    cols: 2,
  },
  {
    src: silly,
    title: 'At Club Cafe',
    rows: 1,
    cols: 1,
  },
  
  {
    src: malta,
    title: 'Taking in the view in Valleta, Malta',
    rows: 2,
    cols: 2,
  },
  
  {
    src: tuxes,
    title: "Looking dapper with Ann Noyes at Ty and Alison's wedding",
    rows: 2,
    cols: 2,
  },
  {
    src: blade,
    title: 'Taking their first helicopter ride ever!',
    rows: 1,
    cols: 1,
  },
  {
    src: mcewan,
    title: 'At McEwan Hall in Edinburgh, UK',
    rows: 1,
    cols: 1,
  },
  
  {
    src: ibiza,
    title: 'Sangria in Ibiza, Spain',
    rows: 2,
    cols: 2,
  },
  {
    src: thailand,
    title: 'Kayaking in Phang Nga Bay, Thailand',
    rows: 1,
    cols: 2,
  },
  {
    src: LA,
    title: 'On the beach in Los Angeles, CA',
    rows: 1,
    cols: 3,
  },
  {
    src: emwed,
    title: "Celebrating at Eliza & Maggie's Wedding",
    rows: 1,
    cols: 1,
  },
  {
    src: berlin,
    title: 'Running through Berlin, Germany',
    rows: 1,
    cols: 1,
  },
  {
    src: miami,
    title: "Celebrating after Court's second proposal",
    rows: 1,
    cols: 1,
  },
  {
    src: jtree,
    title: 'Exploring Joshua Tree, CA',
    rows: 1,
    cols: 1,
  },
  
  {
    src: fishersssm,
    title: 'After running in the Fishers Island Sea-Stretcher Marathon',
    rows: 1,
    cols: 1,
  },
  {
    src: skiing,
    title: 'Skiing at Sugar Loaf',
    rows: 1,
    cols: 2,
  },
  {
    src: fisherNKWeddingGif,
    title: "Cait & Nik Holguin's Wedding",
    rows: 2,
    cols: 2,
  },
  {
    src: silly2,
    title: 'At Club Cafe',
    rows: 2,
    cols: 1,
  },
  {
    src: nye,
    title: 'New Years Eve',
    rows: 2,
    cols: 1,
  },
  {
    src: fireisland,
    title: 'Visiting Fire Island',
    rows: 2,
    cols: 1,
  },
  {
    src: ptown,
    title: 'Ferry to Provincetown 2015!',
    rows: 2,
    cols: 1,
  },
  {
    src: weddings,
    title: 'Out at some weddings!',
    rows: 1,
    cols: 2,
  },
  {
    src: oysters,
    title: 'A tradition is born',
    rows: 1,
    cols: 2,
  },
  {
    src: nyaj,
    title: 'Court and Andrew dining',
    rows: 1,
    cols: 1,
  },
  {
    src: early,
    title: 'Court and Andrew in 2014',
    rows: 1,
    cols: 1,
  },
];

export default function CoupleGallery() {
  return (
    <ImageGalleryGrid images={itemData} />
  );
}
